import { render, staticRenderFns } from "./AddSMPage.vue?vue&type=template&id=601a21a7&scoped=true&"
import script from "./AddSMPage.vue?vue&type=script&lang=js&"
export * from "./AddSMPage.vue?vue&type=script&lang=js&"
import style0 from "./AddSMPage.vue?vue&type=style&index=0&id=601a21a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601a21a7",
  null
  
)

export default component.exports